<template>
  <div class="input-box">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="400px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <p>{{msg}}</p>
      <el-input v-if="type === 'input'" v-model="inputValue" placeholder="请输入" style="width: 100%"></el-input>
      <el-input v-if="type === 'number'" type="number" v-model="inputValue" placeholder="请输入" style="width: 100%"></el-input>
      <el-date-picker v-if="type === 'date'" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="inputValue" placeholder="请选择日期" style="width: 100%"></el-date-picker>
      <el-date-picker v-if="type === 'daterange'" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="inputValue" style="width: 100%"></el-date-picker>
      <el-date-picker v-if="type === 'datetime'" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="inputValue" placeholder="请选择日期时间" style="width: 100%"></el-date-picker>
      <el-date-picker v-if="type === 'month'" type="month" format="yyyy-MM" value-format="yyyy-MM" v-model="inputValue" placeholder="请选择月份" style="width: 100%"></el-date-picker>
      <el-select v-if="type === 'select'" v-model="inputValue" placeholder="请选择" style="width: 100%">
        <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "InputBox",
  data() {
    return {
      dialogVisible: false,
      type:"",
      callback:null,
      inputValue:"",
      list:[],
      msg:"",
    };
  },
  methods: {
    show(type,callback,list=[]){
      this.type = type;
      this.list = list;
      this.dialogVisible = true;
      this.callback = callback;
    },
    submit() {
      this.callback(this.inputValue);
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
      this.callback=null;
      this.type="";
      this.list=[];
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/components/InputBox.vue